export var PotType = {
	MAIN : 1,
	SIDE : 2
}
/**
 * Representation of a pot, there are two types
 * of pots MAIN and SIDE
 *
 * @type {Pot}
 */
export class Pot {
	id : number
	type : number
	amount : any
	/**
     * @constructor
     * @param id - the id of the pot
     * @param type - the Poker.PotType type of the pot
     * @param amount - the pot amount
     */
	constructor(id,type,amount) {
		this.id = id
		this.type = type
		this.amount = amount

	}
}